import { render, staticRenderFns } from "./ServiceTypes.vue?vue&type=template&id=685f0c04&"
import script from "./ServiceTypes.vue?vue&type=script&lang=js&"
export * from "./ServiceTypes.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypes.vue?vue&type=style&index=0&id=685f0c04&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('685f0c04')) {
      api.createRecord('685f0c04', component.options)
    } else {
      api.reload('685f0c04', component.options)
    }
    module.hot.accept("./ServiceTypes.vue?vue&type=template&id=685f0c04&", function () {
      api.rerender('685f0c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServiceTypes.vue"
export default component.exports